export enum SignalEventType {
  MobNotificationUnreadCountNumber = 'MobNotificationUnreadCountNumber',
  NewReservation = 'NewReservation',
  UpdateReservation = 'UpdateReservation',
  CancelReservation = 'CancelReservation',
  menuUpdated = 'menuUpdated',
  menuItemUpdated = 'menuItemUpdated',
  kdsItemStatusChanged = 'kdsItemStatusChanged',
  orderStatusChanged = 'orderStatusChanged',
  newOrderToKds = 'newOrderToKds',
  editOrder = 'editOrder',
  cancelledOrder = 'cancelledOrder',
  recallOrder = 'recallOrder',
  OrderCheckOut = 'OrderCheckOut',
  wasteOrder = 'wasteOrder',
  updatePaymentSettings = 'updatePaymentSettings',
  blockTable = 'blockTable',
  LogOut = 'LogOut',
  TakeawayorderStatusChanged = 'TakeawayorderStatusChanged',
  QrCodeHyperPay = 'QrCodeHyperPay',
  WareHouseSenderReject = 'WareHouseSenderReject',
  WareHouseSenderAccept = 'WareHouseSenderAccept',
  WareHouseReceiver = 'WareHouseReceiver',
  AttandanceFeature = "AttandanceFeature",
  NearPayNFC = "NearPayNFC",
  BlendOrder = "BlendOrder",
  OfflineRefrash = "offlineRefrash"
}

export interface SignalEvent<TDataShape> {
  type: SignalEventType,
  data: TDataShape
}
export enum WareHouseLogSourceEnum {
  PurchaseOrder = 'PurchaseOrder',
  NeedStockRequest = 'NeedStockRequest',
  SendStockRequest = 'SendStockRequest',
}
